import { z } from "zod";
import { zString } from "../../../config/schemas/commonSchemaObjects";

export const metadataFieldSchema = z.object({
  field_name: zString.zRequired,
  field_type: zString.zRequired,
  description: zString.zOptional,
  required: zString.zRequired,
  parent: zString.zOptional,
  title: zString.zOptional,
  max_length: zString.zRequired,
  code_list_value: zString.zOptional,
});

export const metadataCodelistFieldSchema = z.object({
  field_name: zString.zRequired,
  field_type: zString.zRequired,
  description: zString.zOptional,
  required: zString.zRequired,
  parent: zString.zOptional,
  title: zString.zOptional,
  max_length: zString.zRequired,
  code_list_value: zString.zRequired,
});
